export const MY_COMPANY_API_KEY = "clr2yfbgu000008jte4bkgq8s"
export const BEARER_TOKEN = "Bearer 678f4966c3fbd6b084a0a2a1626e388e3f4972321f416baf68d9321611ad7c25"